export default {
  header: {
    business_person: "事業",
  },
};

// operator.layout.header
